import { gql } from '@apollo/client';

export type FetchEspDefinitionsResponse = {
  espDefinitions: string[];
};

export const fetchEspDefinitionsQuery = gql`
  query getEspDefinitions {
    espDefinitions
  }
`;
